import { EventEmitter, Component, ChangeDetectionStrategy, ChangeDetectorRef, Output, ViewChild, Input, NgModule } from '@angular/core';
import { ResponsiveService } from 'b2c-ui/core';
import { Subject, fromEvent } from 'rxjs';
import { tap, filter, map, takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { I18nTransKey, I18nModule } from 'b2c-ui/i18n';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { NzButtonModule, NzToolTipModule, NzGridModule } from 'ng-zorro-antd';
import { NzIconModule, NZ_ICONS } from 'ng-zorro-antd/icon';
import { HeartFill } from '@ant-design/icons-angular/icons';
import { RecommendedFundLogoIcon, AddToWatchlistIcon, AlertIcon, AlertaddedIcon, B2cUiIconModule, B2CUiIconService } from 'b2c-ui-icon';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-fb-base.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'b2c-ui/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'ng-zorro-antd';
import * as ɵngcc4 from 'b2c-ui-icon';
import * as ɵngcc5 from 'b2c-ui/i18n';

const _c0 = ["floatingBar"];
const _c1 = ["*"];
function B2CProductFloatingBarComponent_ng_container_1_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CProductFloatingBarComponent_ng_container_1_div_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "Transact");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function B2CProductFloatingBarComponent_ng_container_1_div_1_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "Subscribe");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function B2CProductFloatingBarComponent_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵtemplate(2, B2CProductFloatingBarComponent_ng_container_1_div_1_ng_container_2_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵelementStart(4, "button", 8);
    ɵngcc0.ɵɵlistener("click", function B2CProductFloatingBarComponent_ng_container_1_div_1_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.transact.emit(); });
    ɵngcc0.ɵɵelementStart(5, "span", 9);
    ɵngcc0.ɵɵtemplate(6, B2CProductFloatingBarComponent_ng_container_1_div_1_ng_container_6_Template, 2, 0, "ng-container", 10);
    ɵngcc0.ɵɵtemplate(7, B2CProductFloatingBarComponent_ng_container_1_div_1_ng_container_7_Template, 2, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.showSubscribeText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.showSubscribeText);
} }
function B2CProductFloatingBarComponent_ng_container_1_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CProductFloatingBarComponent_ng_container_1_div_2_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 16);
    ɵngcc0.ɵɵlistener("click", function B2CProductFloatingBarComponent_ng_container_1_div_2_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.rspNow.emit(); });
    ɵngcc0.ɵɵelementStart(1, "span", 9);
    ɵngcc0.ɵɵtext(2, "Apply RSP");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function B2CProductFloatingBarComponent_ng_container_1_div_2_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r14.showBuyText ? "BUY" : "Transact");
} }
function B2CProductFloatingBarComponent_ng_container_1_div_2_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "Subscribe");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function B2CProductFloatingBarComponent_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵtemplate(2, B2CProductFloatingBarComponent_ng_container_1_div_2_ng_container_2_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 13);
    ɵngcc0.ɵɵtemplate(4, B2CProductFloatingBarComponent_ng_container_1_div_2_button_4_Template, 3, 0, "button", 14);
    ɵngcc0.ɵɵelementStart(5, "button", 15);
    ɵngcc0.ɵɵlistener("click", function B2CProductFloatingBarComponent_ng_container_1_div_2_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.transact.emit(); });
    ɵngcc0.ɵɵelementStart(6, "span", 9);
    ɵngcc0.ɵɵtemplate(7, B2CProductFloatingBarComponent_ng_container_1_div_2_ng_container_7_Template, 2, 1, "ng-container", 10);
    ɵngcc0.ɵɵtemplate(8, B2CProductFloatingBarComponent_ng_container_1_div_2_ng_container_8_Template, 2, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.showRspNow);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r6.showSubscribeText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.showSubscribeText);
} }
function B2CProductFloatingBarComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CProductFloatingBarComponent_ng_container_1_div_1_Template, 8, 3, "div", 3);
    ɵngcc0.ɵɵtemplate(2, B2CProductFloatingBarComponent_ng_container_1_div_2_Template, 9, 4, "div", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.isRevamped);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isRevamped);
} }
function B2CProductFloatingBarComponent_ng_template_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "b2c-ui-icon", 26);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function B2CProductFloatingBarComponent_ng_template_2_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CProductFloatingBarComponent_ng_template_2_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 27);
    ɵngcc0.ɵɵlistener("click", function B2CProductFloatingBarComponent_ng_template_2_button_8_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.rspNow.emit(); });
    ɵngcc0.ɵɵelementStart(1, "span", 9);
    ɵngcc0.ɵɵtext(2, "Apply RSP");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function B2CProductFloatingBarComponent_ng_template_2_button_9_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "b2cI18n");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r28 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r28.showBuyText ? "BUY" : ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r28.I18nTransKey == null ? null : ctx_r28.I18nTransKey.TRANSACT), " ");
} }
function B2CProductFloatingBarComponent_ng_template_2_button_9_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "Subscribe");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function B2CProductFloatingBarComponent_ng_template_2_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 8);
    ɵngcc0.ɵɵlistener("click", function B2CProductFloatingBarComponent_ng_template_2_button_9_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r30 = ɵngcc0.ɵɵnextContext(2); return ctx_r30.transact.emit(); });
    ɵngcc0.ɵɵelementStart(1, "span", 9);
    ɵngcc0.ɵɵtemplate(2, B2CProductFloatingBarComponent_ng_template_2_button_9_ng_container_2_Template, 3, 3, "ng-container", 10);
    ɵngcc0.ɵɵtemplate(3, B2CProductFloatingBarComponent_ng_template_2_button_9_ng_container_3_Template, 2, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r23.showSubscribeText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r23.showSubscribeText);
} }
function B2CProductFloatingBarComponent_ng_template_2_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 28);
    ɵngcc0.ɵɵlistener("click", function B2CProductFloatingBarComponent_ng_template_2_button_10_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ctx_r32.addToWatchlist(ctx_r32.isWatchListAdded); });
    ɵngcc0.ɵɵelement(1, "b2c-ui-icon", 29);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r24.isWatchListAdded ? "added" : "")("nzTooltipTitle", "Add to watch list");
} }
function B2CProductFloatingBarComponent_ng_template_2_button_11_b2c_ui_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "b2c-ui-icon", 33);
} }
function B2CProductFloatingBarComponent_ng_template_2_button_11_b2c_ui_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "b2c-ui-icon", 34);
} }
function B2CProductFloatingBarComponent_ng_template_2_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 30);
    ɵngcc0.ɵɵlistener("click", function B2CProductFloatingBarComponent_ng_template_2_button_11_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r36 = ɵngcc0.ɵɵnextContext(2); return ctx_r36.addToAlert(ctx_r36.isAlertAdded); });
    ɵngcc0.ɵɵtemplate(1, B2CProductFloatingBarComponent_ng_template_2_button_11_b2c_ui_icon_1_Template, 1, 0, "b2c-ui-icon", 31);
    ɵngcc0.ɵɵtemplate(2, B2CProductFloatingBarComponent_ng_template_2_button_11_b2c_ui_icon_2_Template, 1, 0, "b2c-ui-icon", 32);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r25.isAlertAdded ? "added" : "")("nzTooltipTitle", ctx_r25.isAlertAdded ? "Remove alert" : "Add alert");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r25.isAlertAdded);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r25.isAlertAdded);
} }
function B2CProductFloatingBarComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 18);
    ɵngcc0.ɵɵtemplate(2, B2CProductFloatingBarComponent_ng_template_2_ng_container_2_Template, 2, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementStart(3, "h5", 19);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 20);
    ɵngcc0.ɵɵtemplate(6, B2CProductFloatingBarComponent_ng_template_2_ng_container_6_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 21);
    ɵngcc0.ɵɵtemplate(8, B2CProductFloatingBarComponent_ng_template_2_button_8_Template, 3, 0, "button", 22);
    ɵngcc0.ɵɵtemplate(9, B2CProductFloatingBarComponent_ng_template_2_button_9_Template, 4, 2, "button", 23);
    ɵngcc0.ɵɵtemplate(10, B2CProductFloatingBarComponent_ng_template_2_button_10_Template, 2, 2, "button", 24);
    ɵngcc0.ɵɵtemplate(11, B2CProductFloatingBarComponent_ng_template_2_button_11_Template, 3, 4, "button", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.recommended);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.name);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showRspNow);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showTransact);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showWatchList);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showAlert);
} }
function B2CProductFloatingBarComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
class B2CFloatingBarBaseComponent {
    /**
     * @param {?} responsiveService
     */
    constructor(responsiveService) {
        this.responsiveService = responsiveService;
        this.isMobile = false;
        this.fixed = true;
        this.responsiveService
            .isMobileWeb()
            .pipe(tap((/**
         * @param {?} mobile
         * @return {?}
         */
        (mobile) => (this.isMobile = mobile))))
            .subscribe();
    }
}
if (false) {
    /**
     * @type {?}
     * @protected
     */
    B2CFloatingBarBaseComponent.prototype.isMobile;
    /**
     * @type {?}
     * @protected
     */
    B2CFloatingBarBaseComponent.prototype.fixed;
    /**
     * @type {?}
     * @private
     */
    B2CFloatingBarBaseComponent.prototype.responsiveService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-floating-bar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CFloatingBarComponent extends B2CFloatingBarBaseComponent {
    /**
     * @param {?} responsiveService
     * @param {?} cdRef
     */
    constructor(responsiveService, cdRef) {
        super(responsiveService);
        this.cdRef = cdRef;
        this.componentOnInit = new EventEmitter();
        this.componentOnDestroy = new EventEmitter();
        this.destroy = new Subject();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.componentOnInit.emit();
        fromEvent(document, 'scroll')
            .pipe(filter((/**
         * @return {?}
         */
        () => this.isMobile === false)), map((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const DEFAULT_OFFSET = 100;
            /** @type {?} */
            let offset = 100;
            if (this.floatingBar && this.floatingBar.nativeElement) {
                /** @type {?} */
                const nativeElement = this.floatingBar.nativeElement;
                offset = nativeElement.offsetHeight ? nativeElement.offsetHeight : DEFAULT_OFFSET;
            }
            return this.fixed ? offset : offset * 2;
        })), map((/**
         * @param {?} offsetHeight
         * @return {?}
         */
        (offsetHeight) => window.scrollY + window.innerHeight + offsetHeight >= document.body.scrollHeight)), tap((/**
         * @param {?} isBottom
         * @return {?}
         */
        (isBottom) => {
            if (this.isMobile === false) {
                /** @type {?} */
                const prevResult = this.fixed;
                this.fixed = !isBottom;
                if (prevResult !== this.fixed) {
                    this.cdRef.markForCheck();
                }
            }
        })), takeUntil(this.destroy))
            .subscribe();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.componentOnDestroy.emit();
        this.destroy.next();
        this.destroy.complete();
    }
}
B2CFloatingBarComponent.ɵfac = function B2CFloatingBarComponent_Factory(t) { return new (t || B2CFloatingBarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
B2CFloatingBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CFloatingBarComponent, selectors: [["b2c-floating-bar"]], viewQuery: function B2CFloatingBarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.floatingBar = _t.first);
    } }, outputs: { componentOnInit: "componentOnInit", componentOnDestroy: "componentOnDestroy" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1, decls: 3, vars: 1, consts: [[1, "bg-white", "b2c-floating-bar", "p-2", 3, "ngClass"], ["floatingBar", ""]], template: function B2CFloatingBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.fixed ? "position-fixed" : "position-static");
    } }, directives: [ɵngcc2.NgClass], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CFloatingBarComponent.ctorParameters = () => [
    { type: ResponsiveService },
    { type: ChangeDetectorRef }
];
B2CFloatingBarComponent.propDecorators = {
    componentOnInit: [{ type: Output }],
    componentOnDestroy: [{ type: Output }],
    floatingBar: [{ type: ViewChild, args: ['floatingBar', { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CFloatingBarComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-floating-bar',
                template: `
    <div
      #floatingBar
      class="bg-white b2c-floating-bar p-2"
      [ngClass]="fixed ? 'position-fixed' : 'position-static'"
    >
      <ng-content></ng-content>
    </div>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc1.ResponsiveService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { componentOnInit: [{
            type: Output
        }], componentOnDestroy: [{
            type: Output
        }], floatingBar: [{
            type: ViewChild,
            args: ['floatingBar', { static: false }]
        }] }); })();
if (false) {
    /** @type {?} */
    B2CFloatingBarComponent.prototype.componentOnInit;
    /** @type {?} */
    B2CFloatingBarComponent.prototype.componentOnDestroy;
    /** @type {?} */
    B2CFloatingBarComponent.prototype.floatingBar;
    /**
     * @type {?}
     * @private
     */
    B2CFloatingBarComponent.prototype.destroy;
    /**
     * @type {?}
     * @private
     */
    B2CFloatingBarComponent.prototype.cdRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-fb-product.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CProductFloatingBarComponent extends B2CFloatingBarBaseComponent {
    /**
     * @param {?} responsiveService
     */
    constructor(responsiveService) {
        super(responsiveService);
        this.recommended = false;
        this.transact = new EventEmitter();
        this._columnFront = 16;
        this._columnBack = 8;
        /**
         * @ignore
         */
        this.I18nTransKey = I18nTransKey;
        this.showTransact = true;
        /**
         * Watchlist change
         */
        this.watchlistChange = new EventEmitter();
        this.alertChange = new EventEmitter();
        this.rspNow = new EventEmitter();
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set showWatchList(value) {
        this._showWatchList = coerceBooleanProperty(value);
        if (this._showWatchList) {
            this._columnFront = 24;
            this._columnBack = 24;
        }
    }
    /**
     * @ignore
     * @return {?}
     */
    get showWatchList() {
        return this._showWatchList;
    }
    /**
     * Set product added Watchlist
     * @param {?} value
     * @return {?}
     */
    set isWatchListAdded(value) {
        this._isWatchListAdded = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get isWatchListAdded() {
        return this._isWatchListAdded;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set showSubscribeText(value) {
        this._showSubscribeText = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get showSubscribeText() {
        return this._showSubscribeText;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set isRevamped(value) {
        this._isRevamped = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get isRevamped() {
        return this._isRevamped;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set isAlertAdded(value) {
        this._isAlertAdded = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get isAlertAdded() {
        return this._isAlertAdded;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set showAlert(value) {
        this._showAlert = coerceBooleanProperty(value);
        if (this._showAlert) {
            this._columnFront = 24;
            this._columnBack = 24;
        }
    }
    /**
     * @ignore
     * @return {?}
     */
    get showAlert() {
        return this._showAlert;
    }
    /**
     * @ignore
     * @param {?} value
     * @return {?}
     */
    addToWatchlist(value) {
        this._isWatchListAdded = !value;
        this.watchlistChange.emit(this._isWatchListAdded);
    }
    /**
     * @ignore
     * @param {?} value
     * @return {?}
     */
    addToAlert(value) {
        this._isAlertAdded = !value;
        this.alertChange.emit(this.isAlertAdded);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set showRspNow(value) {
        this._showRspNow = coerceBooleanProperty(value);
        if (this._showRspNow) {
            this._columnFront = 24;
            this._columnBack = 24;
        }
    }
    /**
     * @ignore
     * @return {?}
     */
    get showRspNow() {
        return this._showRspNow;
    }
    /**
     * @ignore
     * @return {?}
     */
    get columnFront() {
        return this._columnFront;
    }
    /**
     * @ignore
     * @return {?}
     */
    get columnBack() {
        return this._columnBack;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set showBuyText(value) {
        this._showBuyText = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get showBuyText() {
        return this._showBuyText;
    }
}
B2CProductFloatingBarComponent.ɵfac = function B2CProductFloatingBarComponent_Factory(t) { return new (t || B2CProductFloatingBarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService)); };
B2CProductFloatingBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CProductFloatingBarComponent, selectors: [["b2c-floating-bar-products"]], inputs: { recommended: "recommended", showTransact: "showTransact", showWatchList: "showWatchList", isWatchListAdded: "isWatchListAdded", showSubscribeText: "showSubscribeText", isRevamped: "isRevamped", isAlertAdded: "isAlertAdded", showAlert: "showAlert", showRspNow: "showRspNow", showBuyText: "showBuyText", name: "name" }, outputs: { transact: "transact", watchlistChange: "watchlistChange", alertChange: "alertChange", rspNow: "rspNow" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1, decls: 6, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["webTemplate", ""], ["contentTemplate", ""], ["class", "b2c-fb-mobile-grid container", 4, "ngIf"], ["class", "b2c-fb-mobile-grid-revamped container", 4, "ngIf"], [1, "b2c-fb-mobile-grid", "container"], [1, "d-flex", "flex-column", "b2c-fb-mobile-content", "justify-content-center"], [4, "ngTemplateOutlet"], ["nz-button", "", "nzType", "primary", 3, "click"], [1, "font-weight-bold"], [4, "ngIf"], [1, "b2c-fb-mobile-grid-revamped", "container"], [1, "b2c-fb-mobile-content-revamped"], [1, "b2c-fb-mobile-button-revamped", "d-flex"], ["class", "w-100 mr-1", "nz-button", "", "nzType", "outline", 3, "click", 4, "ngIf"], ["nz-button", "", "nzType", "primary", 1, "w-100", 3, "click"], ["nz-button", "", "nzType", "outline", 1, "w-100", "mr-1", 3, "click"], [1, "d-flex", "justify-content-between", "align-items-center", "container"], [1, "d-flex", "align-items-center", "h-100", "w-30"], [1, "mb-0", "font-weight-bold", "pl-2"], [1, "b2c-fb-web-grid-content", "d-flex", "align-items-center", "py-3"], [1, "b2c-fb-button-container"], ["class", "mr-2", "nz-button", "", "nzType", "outline", 3, "click", 4, "ngIf"], ["nz-button", "", "nzType", "primary", 3, "click", 4, "ngIf"], ["nz-button", "", "nz-tooltip", "", "nzType", "default", "class", "btn-outline-icon align-top", "nzTooltipPlacement", "top", 3, "ngClass", "nzTooltipTitle", "click", 4, "ngIf"], ["nz-button", "", "nzType", "default", "nz-tooltip", "", "class", "btn-outline-icon align-top", "nzTooltipPlacement", "top", 3, "ngClass", "nzTooltipTitle", "click", 4, "ngIf"], ["name", "recommendedFundLogoIcon"], ["nz-button", "", "nzType", "outline", 1, "mr-2", 3, "click"], ["nz-button", "", "nz-tooltip", "", "nzType", "default", "nzTooltipPlacement", "top", 1, "btn-outline-icon", "align-top", 3, "ngClass", "nzTooltipTitle", "click"], ["name", "addToWatchlistIcon"], ["nz-button", "", "nzType", "default", "nz-tooltip", "", "nzTooltipPlacement", "top", 1, "btn-outline-icon", "align-top", 3, "ngClass", "nzTooltipTitle", "click"], ["class", "alert-added", "name", "alertaddedIcon", 4, "ngIf"], ["name", "alertIcon", 4, "ngIf"], ["name", "alertaddedIcon", 1, "alert-added"], ["name", "alertIcon"]], template: function B2CProductFloatingBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "b2c-floating-bar");
        ɵngcc0.ɵɵtemplate(1, B2CProductFloatingBarComponent_ng_container_1_Template, 3, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(2, B2CProductFloatingBarComponent_ng_template_2_Template, 12, 7, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, B2CProductFloatingBarComponent_ng_template_4_Template, 1, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMobile)("ngIfElse", _r1);
    } }, directives: [B2CFloatingBarComponent, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc3.NzButtonComponent, ɵngcc4.B2CUiIconComponent, ɵngcc3.NzTooltipDirective, ɵngcc2.NgClass], pipes: [ɵngcc5.B2CI18nPipe], encapsulation: 2 });
/** @nocollapse */
B2CProductFloatingBarComponent.ctorParameters = () => [
    { type: ResponsiveService }
];
B2CProductFloatingBarComponent.propDecorators = {
    name: [{ type: Input }],
    recommended: [{ type: Input }],
    transact: [{ type: Output }],
    showTransact: [{ type: Input }],
    showWatchList: [{ type: Input }],
    isWatchListAdded: [{ type: Input }],
    showSubscribeText: [{ type: Input }],
    isRevamped: [{ type: Input }],
    isAlertAdded: [{ type: Input }],
    showAlert: [{ type: Input }],
    watchlistChange: [{ type: Output }],
    alertChange: [{ type: Output }],
    showRspNow: [{ type: Input }],
    rspNow: [{ type: Output }],
    showBuyText: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CProductFloatingBarComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-floating-bar-products',
                template: `
    <b2c-floating-bar>
      <ng-container *ngIf="isMobile; else webTemplate">
        <div class="b2c-fb-mobile-grid container" *ngIf="!isRevamped">
          <div class="d-flex flex-column b2c-fb-mobile-content justify-content-center">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
          </div>
          <div>
            <button nz-button nzType="primary" (click)="transact.emit()">
              <span class="font-weight-bold">
                <ng-container *ngIf="!showSubscribeText">Transact</ng-container>
                <ng-container *ngIf="showSubscribeText">Subscribe</ng-container>
              </span>
            </button>
          </div>
        </div>
        <div class="b2c-fb-mobile-grid-revamped container" *ngIf="isRevamped">
          <div class="b2c-fb-mobile-content-revamped">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
          </div>
          <div class="b2c-fb-mobile-button-revamped d-flex">
            <button
              *ngIf="showRspNow"
              class="w-100 mr-1"
              nz-button
              nzType="outline"
              (click)="rspNow.emit()"
            >
              <span class="font-weight-bold">Apply RSP</span>
            </button>
            <button class="w-100" nz-button nzType="primary" (click)="transact.emit()">
              <span class="font-weight-bold">
                <ng-container *ngIf="!showSubscribeText">{{showBuyText ? 'BUY' : 'Transact'}}</ng-container>
                <ng-container *ngIf="showSubscribeText">Subscribe</ng-container>
              </span>
            </button>
          </div>
        </div>
      </ng-container>
      <ng-template #webTemplate>
        <div class="d-flex justify-content-between align-items-center container">
          <div class="d-flex align-items-center h-100 w-30">
            <ng-container *ngIf="recommended">
              <b2c-ui-icon name="recommendedFundLogoIcon"></b2c-ui-icon>
            </ng-container>
            <h5 class="mb-0 font-weight-bold pl-2">{{ name }}</h5>
          </div>
          <div class="b2c-fb-web-grid-content d-flex align-items-center py-3">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
          </div>
          <div class="b2c-fb-button-container">
            <button
              class="mr-2"
              nz-button
              nzType="outline"
              (click)="rspNow.emit()"
              *ngIf="showRspNow"
            >
              <span class="font-weight-bold">Apply RSP</span>
            </button>

            <button nz-button nzType="primary" (click)="transact.emit()" *ngIf="showTransact">
              <span class="font-weight-bold">
                <ng-container *ngIf="!showSubscribeText">
                  {{showBuyText ? 'BUY' : I18nTransKey?.TRANSACT | b2cI18n}}
                </ng-container>
                <ng-container *ngIf="showSubscribeText">Subscribe</ng-container>
              </span>
            </button>

            <button
              *ngIf="showWatchList"
              nz-button
              nz-tooltip
              nzType="default"
              class="btn-outline-icon align-top"
              [ngClass]="isWatchListAdded ? 'added' : ''"
              [nzTooltipTitle]="'Add to watch list'"
              nzTooltipPlacement="top"
              (click)="addToWatchlist(isWatchListAdded)"
            >
              <b2c-ui-icon name="addToWatchlistIcon"></b2c-ui-icon>
            </button>

            <button
              *ngIf="showAlert"
              nz-button
              nzType="default"
              nz-tooltip
              class="btn-outline-icon align-top"
              [ngClass]="isAlertAdded ? 'added' : ''"
              [nzTooltipTitle]="isAlertAdded ? 'Remove alert' : 'Add alert'"
              nzTooltipPlacement="top"
              (click)="addToAlert(isAlertAdded)"
            >
              <b2c-ui-icon
                *ngIf="isAlertAdded"
                class="alert-added"
                name="alertaddedIcon"
              ></b2c-ui-icon>
              <b2c-ui-icon *ngIf="!isAlertAdded" name="alertIcon"></b2c-ui-icon>
            </button>
          </div>
        </div>
      </ng-template>

      <ng-template #contentTemplate>
        <ng-content></ng-content>
      </ng-template>
    </b2c-floating-bar>
  `
            }]
    }], function () { return [{ type: ɵngcc1.ResponsiveService }]; }, { recommended: [{
            type: Input
        }], transact: [{
            type: Output
        }], showTransact: [{
            type: Input
        }], watchlistChange: [{
            type: Output
        }], alertChange: [{
            type: Output
        }], rspNow: [{
            type: Output
        }], showWatchList: [{
            type: Input
        }], isWatchListAdded: [{
            type: Input
        }], showSubscribeText: [{
            type: Input
        }], isRevamped: [{
            type: Input
        }], isAlertAdded: [{
            type: Input
        }], showAlert: [{
            type: Input
        }], showRspNow: [{
            type: Input
        }], showBuyText: [{
            type: Input
        }], name: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    B2CProductFloatingBarComponent.prototype.name;
    /** @type {?} */
    B2CProductFloatingBarComponent.prototype.recommended;
    /** @type {?} */
    B2CProductFloatingBarComponent.prototype.transact;
    /**
     * @type {?}
     * @private
     */
    B2CProductFloatingBarComponent.prototype._showWatchList;
    /**
     * @type {?}
     * @private
     */
    B2CProductFloatingBarComponent.prototype._isWatchListAdded;
    /**
     * @type {?}
     * @private
     */
    B2CProductFloatingBarComponent.prototype._showAlert;
    /**
     * @type {?}
     * @private
     */
    B2CProductFloatingBarComponent.prototype._isAlertAdded;
    /**
     * @type {?}
     * @private
     */
    B2CProductFloatingBarComponent.prototype._showSubscribeText;
    /**
     * @type {?}
     * @private
     */
    B2CProductFloatingBarComponent.prototype._showBuyText;
    /**
     * @type {?}
     * @private
     */
    B2CProductFloatingBarComponent.prototype._isRevamped;
    /**
     * @type {?}
     * @private
     */
    B2CProductFloatingBarComponent.prototype._columnFront;
    /**
     * @type {?}
     * @private
     */
    B2CProductFloatingBarComponent.prototype._columnBack;
    /**
     * @ignore
     * @type {?}
     */
    B2CProductFloatingBarComponent.prototype.I18nTransKey;
    /** @type {?} */
    B2CProductFloatingBarComponent.prototype.showTransact;
    /**
     * Watchlist change
     * @type {?}
     */
    B2CProductFloatingBarComponent.prototype.watchlistChange;
    /** @type {?} */
    B2CProductFloatingBarComponent.prototype.alertChange;
    /**
     * @type {?}
     * @private
     */
    B2CProductFloatingBarComponent.prototype._showRspNow;
    /** @type {?} */
    B2CProductFloatingBarComponent.prototype.rspNow;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-floating-bar.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ICONS = [RecommendedFundLogoIcon, AddToWatchlistIcon, AlertIcon, AlertaddedIcon];
/** @type {?} */
const HEART_ICON = [HeartFill];
/** @type {?} */
const exportingComponents = [
    B2CFloatingBarComponent,
    B2CProductFloatingBarComponent
];
const ɵ0 = HEART_ICON;
class B2CFloatingBarModule {
    /**
     * @param {?} b2cIconService
     */
    constructor(b2cIconService) {
        this.b2cIconService = b2cIconService;
        this.b2cIconService.registerIcons([...ICONS]);
    }
}
B2CFloatingBarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CFloatingBarModule });
B2CFloatingBarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CFloatingBarModule_Factory(t) { return new (t || B2CFloatingBarModule)(ɵngcc0.ɵɵinject(ɵngcc4.B2CUiIconService)); }, providers: [
        { provide: NZ_ICONS, useValue: ɵ0 }
    ], imports: [[
            CommonModule,
            NzButtonModule,
            NzToolTipModule,
            B2cUiIconModule,
            NzGridModule,
            I18nModule,
            NzIconModule
        ]] });
/** @nocollapse */
B2CFloatingBarModule.ctorParameters = () => [
    { type: B2CUiIconService }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CFloatingBarModule, { declarations: function () { return [B2CFloatingBarComponent,
        B2CProductFloatingBarComponent]; }, imports: function () { return [CommonModule,
        NzButtonModule,
        NzToolTipModule,
        B2cUiIconModule,
        NzGridModule,
        I18nModule,
        NzIconModule]; }, exports: function () { return [B2CFloatingBarComponent,
        B2CProductFloatingBarComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CFloatingBarModule, [{
        type: NgModule,
        args: [{
                declarations: [...exportingComponents],
                exports: [...exportingComponents],
                imports: [
                    CommonModule,
                    NzButtonModule,
                    NzToolTipModule,
                    B2cUiIconModule,
                    NzGridModule,
                    I18nModule,
                    NzIconModule
                ],
                providers: [
                    { provide: NZ_ICONS, useValue: ɵ0 }
                ]
            }]
    }], function () { return [{ type: ɵngcc4.B2CUiIconService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CFloatingBarModule.prototype.b2cIconService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-floating-bar.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CFloatingBarBaseComponent, B2CFloatingBarComponent, B2CFloatingBarModule, B2CProductFloatingBarComponent };


//# sourceMappingURL=b2c-ui-floating-bar.js.map